export default class ConfirmationError extends Error {
  constructor() {
    super('User did not confirm');
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, ConfirmationError.prototype);
  }
}
